export enum FlowModelPublishType {
  Workflow = 0,
  ProcessMap = 1,
  WorkflowComponent = 2,
  ProcessMapComponent = 3
}

export enum FlowModelTypeName {
  Workflow = 'Workflow',
  ProcessMap = 'Process Map',
  WorkflowComponent = 'Workflow Component',
  ProcessMapComponent = 'Process Map Component'
}
